module.exports = __webpack_public_path__ + "static/media/CircularPro-Bold.a1692364.svg";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/CircularPro-Bold.svg
// module id = 112
// module chunks = 0